import { ReactNode } from 'react';
import { cn } from '@/lib/utils';
import { TYPOGRAPHY, ICON_SIZES } from '@/lib/design-tokens';

interface PageHeaderProps {
  titulo: string;
  subtitulo?: string;
  icone?: ReactNode;
  badge?: ReactNode;
  acoes?: ReactNode;
  className?: string;
}

/**
 * Cabeçalho padronizado para páginas.
 * Inclui título, subtítulo opcional, ícone, badge e ações.
 */
export function PageHeader({
  titulo,
  subtitulo,
  icone,
  badge,
  acoes,
  className,
}: PageHeaderProps) {
  return (
    <div className={cn('flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between', className)}>
      <div className="flex items-start gap-3">
        {icone && (
          <div className={cn(
            'rounded-lg bg-primary/10 p-2.5 text-primary',
            'flex items-center justify-center'
          )}>
            <div className={ICON_SIZES.header}>
              {icone}
            </div>
          </div>
        )}
        <div className="space-y-1">
          <div className="flex items-center gap-2 flex-wrap">
            <h1 className={TYPOGRAPHY.pageTitle}>{titulo}</h1>
            {badge}
          </div>
          {subtitulo && (
            <p className={TYPOGRAPHY.pageSubtitle}>{subtitulo}</p>
          )}
        </div>
      </div>
      {acoes && (
        <div className="flex items-center gap-3 flex-shrink-0">
          {acoes}
        </div>
      )}
    </div>
  );
}
